module.exports = __webpack_public_path__ + "img/image-3.0383c31b.png";